import {
    SystemControllerNotReportingTroubleshooting,
    ACBatteriesNotReportingTroubleshooting,
    ActivationIncompleteTroubleshooting,
    BatteryNotReportingTroubleshooting,
    MeterNotReportingTroubleshooting,
    LowImpactAlertTroubleshooting,
    UnknownStatusTroubleshooting,
    IconBatteryCharging2,
    IconClock,
    IconFileCheck01,
    IconHelpCircle,
    IconSliders,
    IconSpeedometer,
    IconSize
} from '@/components'
import { InverterManufacturerEnum, SystemStatusEnum } from '@/enums'
import { feature } from '@/services'
import { SystemStatusDataType } from '@/types'

export const SYSTEM_STATUSES_MONITORED_TIER_3: SystemStatusDataType[] = [
    {
        value: SystemStatusEnum.IMPACT_ALERT_LEVEL_3,
        title: 'Low Impact Alert - Level 3',
        refreshable: true,
        secondaryOrder: 6,
        icon: () => 3,
        troubleshooting: <LowImpactAlertTroubleshooting/>,
        description: 'Low-tier alert, indicates a minor issue that should be addressed to maintain system efficiency.' +
            ' For detailed information, please visit your SolarEdge Monitoring portal. Solar Insure only' +
            ' retrieves the Impact Indicator score (1-9), calculated by SolarEdge based on potential energy loss.'
    },
    {
        value: SystemStatusEnum.IMPACT_ALERT_LEVEL_2,
        title: 'Low Impact Alert - Level 2',
        refreshable: true,
        secondaryOrder: 7,
        icon: () => 2,
        troubleshooting: <LowImpactAlertTroubleshooting/>,
        description: 'Alert signifies a small impact issue, low priority but warrants monitoring. For detailed' +
            ' information, please visit your SolarEdge Monitoring portal. Solar Insure only retrieves the Impact' +
            ' Indicator score (1-9), calculated by SolarEdge based on potential energy loss.'
    },
    {
        value: SystemStatusEnum.IMPACT_ALERT_LEVEL_1,
        title: 'Low Impact Alert - Level 1',
        refreshable: true,
        secondaryOrder: 8,
        icon: () => 1,
        troubleshooting: <LowImpactAlertTroubleshooting/>,
        description: 'Minimal impact alert, indicating very low risk, to be addressed in routine maintenance checks.' +
            ' For detailed information, please visit your SolarEdge Monitoring portal. Solar Insure only retrieves' +
            ' the Impact Indicator score (1-9), calculated by SolarEdge based on potential energy loss.'
    },
    {
        value: SystemStatusEnum.BATTERY,
        title: 'AC Batteries Not Reporting',
        refreshable: true,
        secondaryOrder: 1,
        icon: (size: IconSize) => <IconBatteryCharging2 size={size}/>,
        troubleshooting: <ACBatteriesNotReportingTroubleshooting/>,
        description: 'AC battery units are not communicating, possibly due to interference or connection issues.This' +
            ' can usually be addressed by the system owner and should not require and on-site service visit.'
    },
    {
        value: SystemStatusEnum.ENCHARGE,
        title: 'Battery Not Reporting',
        refreshable: true,
        secondaryOrder: 2,
        icon: (size: IconSize) => <IconBatteryCharging2 size={size}/>,
        troubleshooting: <BatteryNotReportingTroubleshooting/>,
        description: 'Battery disconnected and not reporting data. Momentary disruptions in communication due to' +
            ' changes in environmental variables are normal.'
    },
    {
        value: SystemStatusEnum.METER,
        title: 'Meter Not Reporting',
        refreshable: true,
        secondaryOrder: 3,
        icon: (size: IconSize) => <IconSpeedometer size={size}/>,
        troubleshooting: <MeterNotReportingTroubleshooting/>,
        description: 'The system has a revenue grade meter (RGM) that has stopped communicating with the gateway.' +
            ' Occasional instances of this message may be ignored, as a temporary interference to the radio signal' +
            ' may cause this condition.'
    },
    {
        value: SystemStatusEnum.ENPOWER,
        title: 'System Controller Not Reporting',
        refreshable: true,
        secondaryOrder: 4,
        icon: (size: IconSize) => <IconSliders size={size}/>,
        troubleshooting: <SystemControllerNotReportingTroubleshooting/>,
        description: 'The system controller is offline. Momentary disruptions in communication are normal and are' +
            ' seen due to changes in environmental variables.'
    },
    {
        value: SystemStatusEnum.ACTIVATION,
        title: 'Activation Incomplete',
        refreshable: true,
        secondaryOrder: 5,
        icon: (size: IconSize) => <IconFileCheck01 size={size}/>,
        troubleshooting: <ActivationIncompleteTroubleshooting/>,
        description: 'System activation is not fully completed and may need additional setup or configuration steps.'
    },
    {
        value: SystemStatusEnum.UNKNOWN_STATUS,
        title: 'Unknown Status',
        secondaryOrder: 9,
        refreshable: true,
        icon: (size: IconSize) => <IconHelpCircle size={size}/>,
        troubleshooting: <UnknownStatusTroubleshooting/>,
        description: 'This status is assigned when the system status is not known. Log into Generac for more details'
    },
    {
        value: SystemStatusEnum.WAITING_FOR_JUMPSTART_LOW_SOE,
        title: 'Waiting for Jumpstart - Low SOE',
        refreshable: true,
        manufacturer: InverterManufacturerEnum.TESLA,
        icon: (size: IconSize) => <IconClock size={size}/>,
        description: 'The system has been put to sleep due to a low SOE and being off‐grid.'
    }
].filter(({ manufacturer }) => manufacturer !== InverterManufacturerEnum.TESLA || feature('tesla-integration'))
